export default __webpack_public_path__ + "static/934-616acccd7133430d73b5b90ab4e953e2.gif";